export default {
  common: {
    navBarLinks: {
      home: "Accueil",
      career: "Carrière",
      projects: "Projets",
      about: "À propos",
      contact: "Contact",
    },
    notFoundPage: {
      title: "404 - Page non trouvée",
      description:
        "La page que vous recherchez a peut-être été déplacée ou supprimée. Veuillez vérifier l'URL ou utiliser le menu de navigation pour trouver la page correcte.",
      button: "Retourner à l'accueil",
    },
    technicalspecifications: "Spécifications techniques",
    functionalspecifications: "Spécifications fonctionnelles",
    skill: "Compétences",
    skills: {
      react: "React",
      express: "Express",
      mongodb: "MongoDB",
      nodejs: "Node.js",
      tailwind: "Tailwind CSS",
      i18n: "i18n",
      framerMotion: "Framer-motion",
      javascript: "Javascript",
      nextjs: "Next.js",
      sass: "Sass",
      mui: "MUI",
      redux: "Redux",
      rtkQuery: "RTK Query",
      zustand: "Zustand",
      json: "JSON",
      html: "HTML",
      css: "CSS",
      emailjs: "EmailJS",
      npm: "Npm",
      git: "Git",
      github: "GitHub",
      figma: "Figma",
      threejs: "Three.js",
      vite: "Vite",
      tauri: "Tauri",
      gitkraken: "GitKraken",
      gitfork: "Git Fork",
      itDiagnostics: "Diagnostic IT",
      pedagogy: "Pédagogie",
      solutionImplementation: "Mise en œuvre de solutions",
      communication: "Communication",
      hardwareAssistance: "Assistance matérielle",
      softwareDeployment: "Déploiement de logiciels",
      systemAdministration: "Administration système",
      listeningSkills: "Compétences d'écoute",
      needsAnalysis: "Analyse des besoins",
      supportAndTutoring: "Support et tutorat",
      decisionMaking: "Prise de décision",
      animationTechniques: "Techniques d'animation",
      training: "Formation",
      changeManagement: "Gestion du changement",
      qualityControl: "Contrôle de qualité",
      processAnalysis: "Analyse des processus",
      electronicArchiving: "Archivage électronique",
      clientFollowUp: "Suivi client",
      solutionSales: "Vente de solutions",
      legalAssistance: "Assistance juridique",
      organizationalSkills: "Compétences organisationnelles",
      curiosity: "Curiosité",
      rigor: "Rigueur",
      adaptability: "Capacité d'adaptation",
      proactiveness: "Force de proposition",
      teamwork: "Travail en équipe",
      languageFR: "Français",
      languageEN: "Anglais",
    },
  },
}
